jQuery(document).ready(function($) {
    $('.evblocks-tabbed-columns__tabs a').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);
        var tabId = $this.data('tab');

        $this.closest('ul').find('li').removeClass('active');
        $this.closest('li').addClass('active');

        $this.closest('.evblocks-tabbed-columns__content').find('.tab-content').removeClass('active');
        $('#' + tabId).addClass('active');
    });
});
